import { useState } from 'react';
import { cn } from '@/lib/cn';

// Renders an image stored at a GCS path via the /api/logos/file proxy.
// The browser's <img> follows the 302 to the 15-minute signed URL.
export function Thumbnail({
  path,
  alt,
  className,
}: { path?: string | null; alt?: string; className?: string }) {
  const [errored, setErrored] = useState(false);

  if (!path || errored) {
    return (
      <div className={cn('flex shrink-0 items-center justify-center rounded-sm bg-bg font-mono text-[8.5px] text-subtle', className)}>
        {errored ? 'ERR' : 'NONE'}
      </div>
    );
  }

  return (
    <img
      src={`/api/logos/file?path=${encodeURIComponent(path)}`}
      alt={alt || path}
      onError={() => setErrored(true)}
      className={cn('shrink-0 rounded-sm object-contain bg-bg', className)}
      loading="lazy"
    />
  );
}
